<template>
  <footer class="footer" :class="{ 'disable-actions': trainingStep != null }">
    <button v-if="gameLoaded" v-tooltip="tooltips.AVATAR_EDIT" @click="changeAvatarConstructState"
            :class="{ 'menu-element__active': viewAvatarConstruct || trainingStep === 8 }"
            class="menu-element menu-element--no-padding">
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="32" fill="none"/>
        <path
            d="M31.9987 18.6667C32.7059 18.6667 33.3842 18.9476 33.8843 19.4477C34.3844 19.9478 34.6654 20.6261 34.6654 21.3334C34.6654 22.0406 34.3844 22.7189 33.8843 23.219C33.3842 23.7191 32.7059 24 31.9987 24C31.2915 24 30.6132 23.7191 30.1131 23.219C29.613 22.7189 29.332 22.0406 29.332 21.3334C29.332 20.6261 29.613 19.9478 30.1131 19.4477C30.6132 18.9476 31.2915 18.6667 31.9987 18.6667ZM29.9987 25.3334H33.9987C34.7059 25.3334 35.3842 25.6143 35.8843 26.1144C36.3844 26.6145 36.6654 27.2928 36.6654 28V35.3334H34.6654V45.3334H29.332V35.3334H27.332V28C27.332 27.2928 27.613 26.6145 28.1131 26.1144C28.6132 25.6143 29.2915 25.3334 29.9987 25.3334Z"
            fill="#ffffff"/>
      </svg>
    </button>
    <!-- <button v-if="!canUseMicrophone" class="menu-element microphone"
      :class="{ 'menu-element__active': desktopMicrophone }" @click="changeMicrophone">
      <img src="@/assets/new-icons/game/mic.svg" alt=" " class="footer__icon" v-if="!desktopMicrophone" />
      <img src="@/assets/new-icons/game/mic-off.svg" alt=" " class="footer__icon" v-else />
    </button> -->
    <!--      v-if="
        userCall && eventType !== 'recordedTour' && role !== 'guide' && role !== 'lecture'
      " -->
    <button v-tooltip="tooltips.TOGGLE_SOUND" class="menu-element sound" @click="turnOffSound = !turnOffSound">
      <svg v-if="!turnOffSound" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.4279 19.124C19.7593 19.3425 20.2038 19.2446 20.4449 18.883C21.7708 16.8941 22.5693 14.4231 22.5693 11.7111C22.5693 8.9915 21.7557 6.52805 20.4449 4.53168C20.2038 4.16254 19.7593 4.07213 19.4279 4.2906C19.0663 4.52414 19.0135 4.96862 19.2621 5.36789C20.4148 7.12319 21.1304 9.30037 21.1304 11.7111C21.1304 14.1067 20.4148 16.299 19.2621 18.0467C19.0135 18.446 19.0663 18.8905 19.4279 19.124ZM9.67955 18.4611C10.2446 18.4611 10.6589 18.0392 10.6589 17.4817V5.9781C10.6589 5.41309 10.2446 4.96108 9.66448 4.96108C9.28027 4.96108 9.00153 5.11929 8.59473 5.51856L5.44573 8.46415C5.40053 8.50935 5.34026 8.53196 5.27246 8.53196H3.14049C2.02553 8.53196 1.42285 9.1497 1.42285 10.3174V13.1198C1.42285 14.2875 2.02553 14.9053 3.14049 14.9053H5.27246C5.34026 14.9053 5.393 14.9279 5.44573 14.9731L8.59473 17.9413C8.9714 18.3029 9.28781 18.4611 9.67955 18.4611ZM16.3768 17.0825C16.7234 17.2934 17.1452 17.2181 17.3863 16.864C18.3657 15.4778 18.9382 13.6171 18.9382 11.7036C18.9382 9.79005 18.3732 7.92174 17.3863 6.54312C17.1452 6.18904 16.7234 6.10617 16.3768 6.32465C16.0152 6.55065 15.9625 7.00266 16.2337 7.40193C17.0322 8.57716 17.4918 10.1065 17.4918 11.7036C17.4918 13.2931 17.0247 14.8224 16.2337 16.0052C15.97 16.4044 16.0152 16.8489 16.3768 17.0825ZM13.3408 15.0635C13.6648 15.2744 14.0866 15.1991 14.3202 14.8676C14.9304 14.054 15.292 12.9014 15.292 11.7036C15.292 10.5057 14.9304 9.36064 14.3202 8.53949C14.0866 8.20802 13.6648 8.13268 13.3408 8.35115C12.9717 8.59222 12.9039 9.0367 13.1977 9.47364C13.612 10.0688 13.8456 10.8673 13.8456 11.7036C13.8456 12.5398 13.612 13.3308 13.1977 13.9335C12.9039 14.3704 12.9717 14.8149 13.3408 15.0635Z"
            fill="white"/>
      </svg>
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
        <path
            d="M18.3599 15.8076V6.97461C18.3599 6.31543 17.8765 5.78809 17.1997 5.78809C16.7515 5.78809 16.4351 5.98145 15.9517 6.43848L12.5415 9.59375C12.5063 9.62891 12.4624 9.65527 12.4185 9.65527H12.1987L18.3599 15.8076ZM21.436 22.3818C21.7085 22.6455 22.1567 22.6543 22.4204 22.3818C22.6929 22.1006 22.6929 21.6611 22.4204 21.3887L7.02197 5.99902C6.74951 5.72656 6.30127 5.71777 6.02002 5.99902C5.75635 6.2627 5.75635 6.71973 6.02002 6.9834L21.436 22.3818ZM9.54443 17.3896H12.0229C12.1021 17.3896 12.1724 17.416 12.2251 17.4688L15.9517 20.9316C16.3911 21.3535 16.7603 21.5381 17.2085 21.5381C17.7183 21.5381 18.105 21.2744 18.2808 20.7559L8.0415 10.5254C7.74268 10.8594 7.58447 11.3516 7.58447 12.002V15.3418C7.58447 16.7129 8.25244 17.3896 9.54443 17.3896Z"
            fill="white"/>
      </svg>
    </button>
    <button v-if="eventId && (role === 'guide' || role === 'lecture')" class="menu-element" @click="toggleRecord"
            :class="{ 'menu-element__active': isRecording }">
      <img :src="recordingIcon"/>
    </button>
    <button v-if="canUseButtons && eventType !== 'lecture'" class="menu-element eye" v-tooltip="tooltips.VIEW"
            @click="changeViewPort"
            :class="{ 'menu-element__active': turnOffCamera || trainingStep === 5 }">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.0004 18.1748C18.1176 18.1748 22.246 13.2404 22.246 11.7111C22.246 10.1893 18.1101 5.25488 12.0004 5.25488C5.97363 5.25488 1.75488 10.1893 1.75488 11.7111C1.75488 13.2404 5.9661 18.1748 12.0004 18.1748ZM12.008 15.8244C9.71024 15.8244 7.8796 13.9485 7.87207 11.7186C7.86454 9.41336 9.71024 7.60533 12.008 7.60533C14.2906 7.60533 16.1363 9.4209 16.1363 11.7186C16.1363 13.9485 14.2906 15.8244 12.008 15.8244ZM12.008 13.2479C12.8517 13.2479 13.5523 12.5548 13.5523 11.7186C13.5523 10.8749 12.8517 10.1742 12.008 10.1742C11.1491 10.1742 10.4561 10.8749 10.4561 11.7186C10.4561 12.5548 11.1491 13.2479 12.008 13.2479Z"
            fill="white"/>
      </svg>
    </button>
    <button v-if="canUseMicrophone && canUseButtons && myMediaStream" class="menu-element microphone"
            @click="changeMicrophone" :class="{ 'menu-element__active': turnOffMicrophone }">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="bi:mic-mute" clip-path="url(#clip0_482_1243)">
          <g id="Group">
            <path id="Vector"
                  d="M19.5 12C19.5 12.846 19.359 13.6605 19.101 14.4195L17.88 13.1985C17.9599 12.804 18.0001 12.4025 18 12V10.5C18 10.3011 18.079 10.1103 18.2197 9.96969C18.3603 9.82904 18.5511 9.75002 18.75 9.75002C18.9489 9.75002 19.1397 9.82904 19.2803 9.96969C19.421 10.1103 19.5 10.3011 19.5 10.5V12ZM12 18C13.227 18 14.367 17.6325 15.318 16.9995L16.395 18.078C15.3242 18.8545 14.0663 19.3323 12.75 19.4625V22.5H17.25C17.4489 22.5 17.6397 22.579 17.7803 22.7197C17.921 22.8603 18 23.0511 18 23.25C18 23.4489 17.921 23.6397 17.7803 23.7803C17.6397 23.921 17.4489 24 17.25 24H6.75C6.55109 24 6.36032 23.921 6.21967 23.7803C6.07902 23.6397 6 23.4489 6 23.25C6 23.0511 6.07902 22.8603 6.21967 22.7197C6.36032 22.579 6.55109 22.5 6.75 22.5H11.25V19.4625C9.40003 19.2766 7.68506 18.4101 6.43782 17.0312C5.19058 15.6523 4.49998 13.8593 4.5 12V10.5C4.5 10.3011 4.57902 10.1103 4.71967 9.96969C4.86032 9.82904 5.05109 9.75002 5.25 9.75002C5.44891 9.75002 5.63968 9.82904 5.78033 9.96969C5.92098 10.1103 6 10.3011 6 10.5V12C6 13.5913 6.63214 15.1174 7.75736 16.2427C8.88258 17.3679 10.4087 18 12 18ZM16.5 4.50002V11.8185L15 10.3185V4.50002C15.0035 3.71741 14.701 2.96443 14.157 2.40172C13.6131 1.83901 12.8708 1.51114 12.0886 1.48804C11.3063 1.46495 10.5459 1.74846 9.96977 2.2781C9.3936 2.80774 9.04721 3.54157 9.0045 4.32302L7.737 3.05552C8.08041 2.04638 8.7708 1.19185 9.68525 0.644068C10.5997 0.0962821 11.6789 -0.109215 12.7307 0.0641608C13.7824 0.237536 14.7386 0.778533 15.4288 1.59084C16.1191 2.40315 16.4986 3.43405 16.5 4.50002Z"
                  fill="#ffffff"/>
            <path id="Vector_2"
                  d="M14.2288 15.9105L13.1068 14.7885C12.6517 14.9692 12.1593 15.0357 11.6726 14.9823C11.1859 14.9289 10.7197 14.7572 10.3146 14.4822C9.9095 14.2071 9.5779 13.8371 9.34871 13.4045C9.11952 12.9718 8.99972 12.4896 8.99975 12V10.683L7.49975 9.18299V12C7.49952 12.788 7.7062 13.5622 8.09911 14.2452C8.49203 14.9282 9.05741 15.4961 9.7387 15.892C10.42 16.288 11.1933 16.4981 11.9813 16.5013C12.7692 16.5045 13.5442 16.3008 14.2288 15.9105ZM2.46875 2.03099L20.4688 20.031L21.5308 18.969L3.53075 0.968994L2.46875 2.03099Z"
                  fill="#ffffff"/>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_482_1243">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </button>
    <button class="menu-element emotions" v-if="false" @click="emotionsOpen = !emotionsOpen"
            :class="{ 'menu-element__active': emotionsOpen || trainingStep === 4 }">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.15625 0C6.43281 0 6.49844 0.01875 6.70938 0.154687C6.85 0.239062 7 0.384375 7.06094 0.492188C7.13125 0.609375 7.22969 0.946875 7.31875 1.38281C7.39844 1.77188 7.525 2.2875 7.60469 2.53125C7.67969 2.775 7.8625 3.21094 8.00312 3.49219C8.14375 3.77344 8.35469 4.14375 8.47187 4.3125C8.58906 4.48125 8.81406 4.77188 8.97344 4.95938C9.12812 5.14688 9.30156 5.31094 9.35312 5.325C9.40469 5.33906 10.3516 5.54531 13.4781 6.22031L14.7531 6.05156C15.4516 5.95781 16.0375 5.87344 16.0562 5.85938C16.0703 5.84531 15.85 5.11875 15.5641 4.24219C15.2734 3.36562 15.0297 2.54063 15.0156 2.41406C14.9969 2.26406 15.0156 2.09531 15.0625 1.94531C15.1047 1.81406 15.2078 1.64531 15.2922 1.56094C15.3766 1.48125 15.5312 1.38281 15.6344 1.34063C15.7375 1.29844 15.9484 1.26562 16.1031 1.26562C16.3047 1.26562 16.4406 1.29375 16.5953 1.37344C16.7125 1.43437 16.8719 1.56562 16.9469 1.66875C17.0266 1.76719 17.1484 2.01094 17.2188 2.20312C17.2891 2.39531 17.65 3.44531 18.025 4.5375C18.6063 6.225 18.7047 6.55781 18.7047 6.79688C18.7047 6.95156 18.6766 7.14844 18.6438 7.22812C18.6109 7.3125 18.5172 7.43906 18.4422 7.50937C18.3672 7.57969 18.2313 7.67344 18.1422 7.71094C18.0531 7.75313 17.0828 7.90313 13.9937 8.325L13.9563 9.91406C13.9375 10.7906 13.9281 12.0562 13.9375 12.7266C13.9469 13.8281 13.9609 14.0109 14.0781 14.625C14.1484 15 14.2609 15.5672 14.3219 15.8906C14.3875 16.2141 14.4578 16.5562 14.5328 16.8281L14.8 16.6781C14.95 16.5984 15.3156 16.3687 15.6109 16.1719C15.9062 15.9703 16.3938 15.6281 16.6891 15.4031C17.0406 15.1406 17.3078 14.9719 17.4625 14.9297C17.5891 14.8922 17.7391 14.8594 17.7906 14.8594C17.8422 14.8594 17.9875 14.8922 18.1188 14.9297C18.2453 14.9672 18.4375 15.0703 18.5406 15.1594C18.6438 15.2437 18.7891 15.4359 18.8641 15.5906C18.9766 15.8109 19.0047 15.9281 19.0047 16.1719C19.0047 16.3734 18.9719 16.5469 18.9109 16.6875C18.8594 16.8047 18.7328 16.9781 18.6297 17.0766C18.5312 17.175 18.1844 17.4422 17.8609 17.6719C17.5375 17.9016 16.9563 18.2766 16.5719 18.5062C16.1828 18.7359 15.6344 19.05 15.3531 19.2047C15.0672 19.3594 14.7297 19.5234 14.6031 19.575C14.4437 19.6359 14.2562 19.6641 14.0172 19.6641C13.7453 19.6594 13.6094 19.6359 13.4078 19.5422C13.2672 19.4766 13.0703 19.35 12.9672 19.2609C12.8688 19.1719 12.7328 19.0078 12.6672 18.8906C12.6016 18.7734 12.5172 18.5859 12.4844 18.4688C12.4469 18.3516 12.3156 17.7 12.1844 17.0156C12.0109 16.0875 11.9219 15.7219 11.8328 15.5719C11.7625 15.45 11.65 15.3422 11.5328 15.2812C11.4297 15.2297 11.2516 15.1875 11.1344 15.1875C11.0172 15.1875 10.8766 15.2109 10.8156 15.2391C10.7594 15.2672 10.6609 15.3375 10.6047 15.3937C10.5437 15.4453 10.4594 15.5578 10.4219 15.6328C10.3797 15.7078 10.3094 16.0031 10.2625 16.2891C10.2156 16.575 10.1641 17.0578 10.1453 17.3672C10.1266 17.7047 10.1359 18.1359 10.1687 18.4453C10.2016 18.7313 10.2578 19.1203 10.2953 19.3125C10.3375 19.5047 10.4453 19.8937 10.5344 20.1797C10.6328 20.4797 10.8766 21.0422 11.1203 21.5156C11.3969 22.0547 11.5516 22.4109 11.5656 22.5469C11.5797 22.6734 11.5609 22.8609 11.5187 23.0156C11.4812 23.1562 11.3781 23.3672 11.2891 23.4797C11.2 23.6016 11.0219 23.7516 10.8531 23.8406C10.6234 23.9719 10.5203 24 10.2906 24C10.1078 24 9.92969 23.9672 9.78437 23.9062C9.6625 23.8547 9.47031 23.7234 9.35781 23.6109C9.25 23.5031 9.0625 23.2547 8.95469 23.0625C8.84219 22.8703 8.65937 22.5187 8.55156 22.2891C8.43906 22.0594 8.28437 21.6891 8.20469 21.4688C8.125 21.2484 7.99844 20.8266 7.92344 20.5312C7.84375 20.2359 7.75 19.7625 7.7125 19.4766C7.66562 19.1578 7.6375 18.6281 7.63281 18.0938C7.63281 17.5453 7.66094 17.0203 7.7125 16.6641C7.75469 16.3547 7.83906 15.8578 7.90469 15.5625C7.975 15.2672 8.13906 14.6766 8.53281 13.4766V8.10938L7.95156 7.53281C7.63281 7.21875 7.225 6.75938 7.04688 6.51562C6.86406 6.27187 6.625 5.92031 6.51719 5.74219C6.40469 5.56406 6.19844 5.17969 6.05781 4.89844C5.91719 4.61719 5.72969 4.18125 5.64062 3.9375C5.55156 3.69375 5.41562 3.27187 5.34062 3C5.26094 2.72813 5.15781 2.27344 5.10625 1.99219C5.05 1.71094 5.00781 1.35 5.00781 1.19531C5.00781 1.03125 5.04062 0.834375 5.0875 0.726562C5.12969 0.623438 5.20937 0.478125 5.26094 0.407812C5.3125 0.3375 5.46719 0.215625 5.59844 0.140625C5.8 0.0234375 5.88906 0 6.15156 0L6.15625 0ZM11.7484 1.12969C11.9031 1.12969 12.1328 1.15312 12.2641 1.19062C12.3906 1.22344 12.6016 1.30312 12.7328 1.37344C12.8594 1.43906 13.0703 1.59375 13.1922 1.72031C13.3187 1.84219 13.4688 2.03906 13.5297 2.15625C13.5859 2.27344 13.6703 2.48438 13.7125 2.625C13.7547 2.76562 13.7875 2.98594 13.7875 3.11719C13.7875 3.24375 13.7547 3.47344 13.7172 3.61875C13.6797 3.76875 13.6 3.97969 13.5437 4.0875C13.4922 4.2 13.3469 4.39219 13.225 4.52344C13.1031 4.65 12.8969 4.81406 12.775 4.88437C12.6484 4.95469 12.4188 5.04375 12.2641 5.08125C12.1094 5.12344 11.875 5.15625 11.7484 5.15625C11.6172 5.15625 11.3969 5.12344 11.2563 5.08125C11.1156 5.03906 10.9047 4.95469 10.7875 4.89844C10.6703 4.8375 10.4734 4.6875 10.3516 4.56094C10.225 4.43906 10.0703 4.22813 10.0047 4.10156C9.93437 3.97031 9.85469 3.75938 9.82187 3.63281C9.78437 3.50156 9.75625 3.28125 9.75625 3.14062C9.75625 3 9.78437 2.775 9.82187 2.64844C9.85469 2.51719 9.93437 2.30625 10.0047 2.17969C10.0703 2.04844 10.225 1.84219 10.3516 1.72031C10.4734 1.59375 10.6797 1.43906 10.8109 1.37344C10.9375 1.30312 11.1391 1.22344 11.2563 1.19062C11.3734 1.15781 11.5938 1.12969 11.7484 1.12969Z"
              fill="#ffffff"/>
      </svg>
    </button>
    <button v-if="canUseButtons && eventType !== 'lecture' && isVdnh && showScooter" v-tooltip="tooltips.SCOOTER"
            class="menu-element scooter"
            @click="scooterActive = !scooterActive"
            :class="{ 'menu-element__active': scooterActive || trainingStep === 3 }">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.8748 12.375H19.8111L18.5567 8.61469L16.8167 3.39469C16.7421 3.17067 16.5989 2.97579 16.4075 2.83765C16.216 2.69951 15.9859 2.62511 15.7498 2.625H12.7498C12.4514 2.625 12.1653 2.74353 11.9543 2.9545C11.7433 3.16548 11.6248 3.45163 11.6248 3.75C11.6248 4.04837 11.7433 4.33452 11.9543 4.5455C12.1653 4.75647 12.4514 4.875 12.7498 4.875H14.9389L16.2298 8.74687L11.0736 15.375H7.7998C7.62138 14.4976 7.13491 13.713 6.42835 13.163C5.72179 12.6131 4.84177 12.3341 3.9474 12.3765C3.05304 12.4189 2.20336 12.7799 1.55201 13.3942C0.900647 14.0086 0.490597 14.8357 0.395997 15.726C0.301396 16.6164 0.528489 17.5112 1.03621 18.2487C1.54394 18.9862 2.29879 19.5177 3.16427 19.7471C4.02976 19.9765 4.94876 19.8886 5.75511 19.4994C6.56146 19.1102 7.20194 18.4453 7.56074 17.625H11.6248C11.7961 17.625 11.9651 17.5859 12.1189 17.5107C12.2728 17.4354 12.4074 17.3261 12.5126 17.1909L17.0848 11.3128L17.6773 13.0941C16.9554 13.62 16.445 14.3863 16.2378 15.255C16.0306 16.1238 16.1403 17.038 16.5471 17.8331C16.9539 18.6282 17.6312 19.252 18.4569 19.5922C19.2827 19.9325 20.2028 19.9668 21.0517 19.689C21.9005 19.4113 22.6224 18.8397 23.0873 18.0771C23.5522 17.3145 23.7297 16.411 23.5878 15.5292C23.446 14.6474 22.994 13.8453 22.3133 13.267C21.6326 12.6888 20.7679 12.3725 19.8748 12.375ZM4.1248 17.625C3.82813 17.625 3.53812 17.537 3.29145 17.3722C3.04477 17.2074 2.85251 16.9731 2.73898 16.699C2.62545 16.4249 2.59575 16.1233 2.65362 15.8324C2.7115 15.5414 2.85436 15.2741 3.06414 15.0643C3.27392 14.8546 3.54119 14.7117 3.83217 14.6538C4.12314 14.5959 4.42474 14.6256 4.69883 14.7392C4.97292 14.8527 5.20718 15.045 5.37201 15.2916C5.53683 15.5383 5.6248 15.8283 5.6248 16.125C5.6248 16.5228 5.46677 16.9044 5.18546 17.1857C4.90416 17.467 4.52263 17.625 4.1248 17.625ZM19.8748 17.625C19.5781 17.625 19.2881 17.537 19.0414 17.3722C18.7948 17.2074 18.6025 16.9731 18.489 16.699C18.3754 16.4249 18.3457 16.1233 18.4036 15.8324C18.4615 15.5414 18.6044 15.2741 18.8141 15.0643C19.0239 14.8546 19.2912 14.7117 19.5822 14.6538C19.8731 14.5959 20.1747 14.6256 20.4488 14.7392C20.7229 14.8527 20.9572 15.045 21.122 15.2916C21.2868 15.5383 21.3748 15.8283 21.3748 16.125C21.3748 16.5228 21.2168 16.9044 20.9355 17.1857C20.6542 17.467 20.2726 17.625 19.8748 17.625Z"
            fill="#ffffff"/>
      </svg>
    </button>
    <button v-if="canUseButtons && eventType !== 'lecture' && !isAtom" v-tooltip="tooltips.MAP" class="menu-element map"
            @click="onToggleMap('main')"
            :class="{ 'menu-element__active': viewMap || trainingStep === 2 }">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11.2012 1.10003C13.8012 0.800025 16.3012 1.70003 18.2012 3.40003C20.0012 5.00003 21.0012 7.3 21.0012 9.7C21.0012 11.5 20.5012 13.2 19.4012 14.7L14.3012 21.8C13.8012 22.6 12.9012 23 12.0012 23C11.1012 23 10.2012 22.6 9.80119 21.9L4.70117 14.8C3.20117 12.8 2.70117 10.4 3.20117 8C3.90117 4.30003 7.20119 1.40003 11.2012 1.10003ZM15.3996 9.70017C15.3996 11.5779 13.8773 13.1002 11.9996 13.1002C10.1218 13.1002 8.59961 11.5779 8.59961 9.70017C8.59961 7.82237 10.1218 6.30017 11.9996 6.30017C13.8773 6.30017 15.3996 7.82237 15.3996 9.70017Z"
              fill="white"/>
      </svg>
    </button>
    <button
        v-if="canUseButtons && isPavilion" @click="onToggleMap('pavilion')"
        v-tooltip="tooltips.PAVILION_MAP"
        class="menu-element map"
        :class="{ 'menu-element__active': viewPavilionMap }"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4745_4367)">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.75 -0.25H8.25V2.81066L5.53033 5.53033L4.46967 4.46967L6.75 2.18934V1.25H2.25V13.75H13.75V1.25H11.5V-0.25H15.25V15.25H0.75V-0.25Z"
                fill="#fff"/>
        </g>
        <defs>
          <clipPath id="clip0_4745_4367">
            <rect width="16" height="16" fill="white" transform="translate(16) rotate(90)"/>
          </clipPath>
        </defs>
      </svg>

    </button>
    <div class="modal modal__emotions" :class="{ modal__open: emotionsOpen }">
      <div class="emotions-list">
        <button class="emotion-element" v-for="emotion in emotions" :class="emotion.class" :key="emotion.id"
                @click="sendEmotions(emotion?.val)">
          <img :src="emotion.emotionUrl" alt="emoji" class="emotion"/>
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
import { useMetrics } from "@/composables/use.metrics";
import locations from "@/lib/locations.json";
import { russiaMapNames } from "@/lib/russia";
import { tooltips } from "@/lib/tooltips";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
// import {appConfig} from "@/lib/appConfig";

export default {
  name: "GameFooter",
  props: [
    "userCall",
    "myMediaStream",
    "role",
    "viewMap",
    "viewPavilionMap",
    "canUseButtons",
    "eventType",
    "trainingStep",
    "eventId",
    "viewAvatarConstruct",
    "gameLoaded",
    "isVdnh",
    "currentEvent"
  ],
  setup(props, {emit}) {
    const emotions = [
      {
        emotionUrl: require("@/assets/icons/emotions/danse.svg"),
        val: 0,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/hands.svg"),
        val: 1,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/cheer.svg"),
        val: 2,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/talk.svg"),
        val: 3,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/ldle.svg"),
        val: 4,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/talk.svg"),
        val: 5,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/eye.svg"),
        val: 7,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/close.svg"),
        val: 8,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/gesture.svg"),
        val: 9,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/lought-1.svg"),
        val: 10,
      },
      // {
      //   emotionUrl: require("@/assets/icons/emotions/lought-2.svg"),
      //   val: "Anim_Dialogue_Sad_talk_02"
      // },
      {
        emotionUrl: require("@/assets/icons/emotions/lought-3.svg"),
        val: 12,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/ear.svg"),
        val: 13,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/hmm.svg"),
        val: 14,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/wow.svg"),
        val: 15,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/sad-1.svg"),
        val: 16,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/sad-2.svg"),
        val: 17,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/sad-3.svg"),
        val: 18,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/angre.svg"),
        val: 19,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/silencs.svg"),
        val: 20,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/talk.svg"),
        val: 21,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/no.svg"),
        val: 22,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/snob.svg"),
        val: 23,
      },
      {
        emotionUrl: require("@/assets/icons/emotions/ear-left.svg"),
        val: 24,
        class: "emotion-element--big",
      },
      {
        emotionUrl: require("@/assets/icons/emotions/ear-right.svg"),
        val: 25,
        class: "emotion-element--big",
      },
      {
        emotionUrl: require("@/assets/icons/emotions/ear-left-top.svg"),
        val: 26,
        class: "emotion-element--big",
      },
      {
        emotionUrl: require("@/assets/icons/emotions/ear-left-top.svg"),
        val: 27,
        class: "emotion-element--big",
      },
      {
        emotionUrl: require("@/assets/icons/emotions/idk.svg"),
        val: 28,
      },
    ];

    const store = useStore();
    const { hit, hitType, getMetricsEventType } = useMetrics();
    const metricsEventType = getMetricsEventType(props.currentEvent);
    const route = useRoute()

    const desktopMicrophone = computed(() => store.getters.desktopMicrophone);
    const isRecording = computed(() => store.getters.isRecording);

    const recordingIcon = computed(() =>
        require(`@/assets/icons/controls/${isRecording.value ? "stop" : "rec"}.svg`)
    );

    const isPavilion = computed(() => russiaMapNames.includes(store.state.application.currentLevelName) || route.query.place?.trim() === locations.atom.place?.trim());
    const showScooter = computed(() => store.state.application.currentLevelName === 'L_VDNH_WP')

    const isAtom = computed(() => locations.atom.place === route.query.place)

    const turnOffCamera = ref(0);

    const emotionsOpen = ref(false);

    const turnOffSound = ref(false);

    const scooterActive = ref(false);

    const canUseMicrophone = computed(() => {
      // if (store.getters?.currentEvent) {
      //   const {mapPath} = store.getters.currentEvent;

      //   if (mapPath?.includes("L_01_INT_0010")) {
      //     return true;
      //   }
      // }

      // return appConfig.isDesktopApp;

      return false;
    });

    function onToggleMap(type) {
      emit('toggle-map', type)
    }

    const changeTurnOffCamera = (val) => {
      turnOffCamera.value = val;
    };
    const changeMicrophone = () => {
      store.commit("setDesktopMicrophoneStatus", !desktopMicrophone.value);
    };

    const sendEmotions = (val) => {
      document.dispatchEvent(new CustomEvent("Emotion", {detail: val}));
    };

    watch(
        () => turnOffSound.value,
        (val) => {
          if (val) {
            // document.getElementById(props.userCall?.peer)?.pause()
            document.dispatchEvent(
                new CustomEvent("SetAudioVolume", {
                  detail: 0,
                })
            );
          } else {
            // document.getElementById(props.userCall?.peer)?.play();
            document.dispatchEvent(
                new CustomEvent("SetAudioVolume", {
                  detail: 1,
                })
            );
          }
        }
    );

    watch(
        () => scooterActive.value,
        (val) => {
          document.dispatchEvent(new CustomEvent("Scooter", {detail: val}));
        }
    );

    watch(
        () => props.turnOffMicrophone,
        (val) => {
          if (isRecording.value) {
            store.dispatch(val ? "onMuteMicrophone" : "offMuteMicrophone");
          }
        }
    );

    onMounted(() => {
      window.addEventListener('UI_scooter', onScooterListener);
      window.addEventListener('UI_exitscooter', onScooterListener);
    })

    onBeforeUnmount(() => {
      store.dispatch("closeConnection");
      window.removeEventListener('UI_scooter', onScooterListener);
      window.removeEventListener('UI_exitscooter', onScooterListener);
    });


    function onScooterListener({detail}) {
      scooterActive.value = detail;

      if (scooterActive.value) {
        if (metricsEventType) {
          hit(metricsEventType, hitType.INTERACTION_SCOOTER, props.currentEvent);
        }
      }
    }

    const toggleRecord = () => {
      if (!isRecording.value) {
        store.dispatch("startRecording", props.eventId, props.turnOffMicrophone);

        if (metricsEventType) {
          hit(metricsEventType, hitType.START_RECORD, props.currentEvent);
        }


      } else {
        store.dispatch("stopRecording");
      }
    };
    return {
      turnOffSound,
      turnOffCamera,
      canUseMicrophone,
      desktopMicrophone,
      isPavilion,
      openPavilionMap: () => {
        emit("openPavilionMap");
      },

      openMap: () => {
        emit("openMap");
      },
      changeViewPort: () =>
          document.dispatchEvent(
              new CustomEvent("ChangeViewportOutput", {detail: turnOffCamera.value ? 0 : 1})
          ),
      changeTurnOffCamera,
      changeMicrophone,
      emotionsOpen,
      emotions,
      scooterActive,
      sendEmotions,
      toggleRecord,
      recordingIcon,
      isRecording,
      onToggleMap,
      changeAvatarConstructState() {
        emit("changeAvatarConstructState");
      },
      tooltips,
      showScooter,
      isAtom,
    };
  },
};
</script>

<style scoped>
.footer {
  display: flex;
  gap: 1rem;
  position: fixed;
  z-index: 2;
  bottom: 1rem;
  padding: 0.5rem;
  border-radius: 3rem;
  background: rgba(157, 196, 248, 0.3);
  backdrop-filter: blur(40px);
}

.menu-element {
  background-color: #ffffff4d;
  border-radius: 100%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
}

.menu-element svg {
  width: 1.2rem;
}

.menu-element img {
  width: 1.2rem;
  height: 1.2rem;
}

.menu-element--no-padding {
  padding: 0;
}

.menu-element--no-padding svg {
  width: 100%;
  height: 100%;
}

.menu-element__active {
  background: #003099;
}

.menu-element__active path {
  fill: #fff;
  stroke: #fff;
}

.menu-element__active circle {
  fill: #003099;
}

.modal {
  position: absolute;
  transform: translateY(20%);
  opacity: 0;
  transition: all 0.5s ease-in-out;
  z-index: 3;
  pointer-events: none;
}

.modal__open {
  transform: translateY(0%);
  opacity: 1;
  pointer-events: all;
}

.modal__emotions {
  bottom: 5rem;
  width: 29.5rem;
  left: calc(50% - 14.25rem);
  background: none;
}

.emotions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  border-radius: 1rem;
  background: rgba(157, 196, 248, 0.3);
  backdrop-filter: blur(4px);
  padding: 0.5rem;
}

.emotion-element {
  padding: 0.5rem;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: #ffffff4d;
  border-radius: 100%;
}

.emotion-element--big {
  border-radius: 20%;
}

@media (max-width: 1000px) {
  .desktop {
    display: none;
  }

  .footer {
    padding: 0.25rem;
    gap: 0.5rem;
    border-radius: 2.5rem;
  }

  .menu-element {
    width: 2rem;
    height: 2rem;
  }

  .menu-element svg {
    width: 0.75rem;
  }

  .menu-element img {
    width: 0.75rem;
  }

  /* .menu-element--no-padding {
    display: none;
  } */
  .menu-element--no-padding svg {
    width: 100%;
  }

  .emotions-list {
    padding: 0.25rem;
    border-radius: 0.5rem;
    width: 24.5rem;
    left: calc(50% - 12.25rem);
  }

  .modal__emotions {
    bottom: 3rem;
    width: 18.5rem;
  }

  .emotion-element {
    padding: 0.25rem;
  }

  .emotion-element img {
    width: 0.875rem;
  }

  .emotion-element--big img {
    width: 1.875rem;
  }
}
</style>
